// this is an automatically generated file from the ßoilerplate framework for app

// /srv/codepad-project/@vue-modules/app/vue;
import base from '@/app.router.base.js';


export default { base,  };